import { render, staticRenderFns } from "./ReturnStorage.vue?vue&type=template&id=1879b86a&scoped=true&"
import script from "./ReturnStorage.vue?vue&type=script&lang=js&"
export * from "./ReturnStorage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1879b86a",
  null
  
)

export default component.exports